import Article, {
  ArticleContentBox,
  DisclaimerBox,
  DisclaimerText,
  DisclaimerTitle,
} from '../shared_components/Library/Article'
import { H3, P, Strong } from '../shared_components/Library/Typeography'
import { Box } from '../shared_components/UI/Box'
import { ThemedAnchor, ThemedLink } from '../shared_components/ThemedButton'
import routes from '../router/routes'
import Bank from '../shared_components/Icons/Bank'
import Eye from '../shared_components/Icons/Eye'
import CoinSwap01 from '../shared_components/Icons/CoinSwap01'

const ZapLabsArticle = () => {
  return (
    <Article
      bannerUrl="/how-it-works-labs-banner.png"
      title="Meet ZAP Labs. The best way to access private markets"
      content={
        <>
          <ArticleContentBox>
            <H3 fw="semibold">Why ZAP Labs?</H3>
            <P c="text-secondary">
              <Strong>Vetted projects.</Strong>
              All ZAP Labs projects have been extensively vetted by the ZAP
              team. You can trust that only the most promising, high-growth
              projects make it to ZAP Labs
            </P>
            <P c="text-secondary">
              <Strong>Fully transparent.</Strong> We share all the information
              you need to make your decision. From vesting to tokenomics to
              project information, you can find everything in the projects raise
              page
            </P>
            <P c="text-secondary">
              <Strong>Simple process.</Strong>ZAP Labs is super simple to use.
              Simply deposit your ETH or raise token and vest your tokens
              through our in-built vesting page.
            </P>
          </ArticleContentBox>
          <ArticleContentBox>
            <H3 fw="semibold">How it Works</H3>
            <P c="text-secondary">
              <Box g={10}>
                <Eye color="white" />
                Browse projects on our explore page
              </Box>
            </P>
            <P c="text-secondary">
              <Box g={10}>
                <CoinSwap01 color="white" />
                Contribute to live raises. For some projects you’ll need to
                complete KYC
              </Box>
            </P>
            <P c="text-secondary">
              <Box g={10}>
                <Bank color="white" />
                Vest your tokens in the vesting dashboard once the project
                generates its token.
              </Box>
            </P>
          </ArticleContentBox>
          <DisclaimerBox>
            <DisclaimerTitle>Disclaimer</DisclaimerTitle>
            <DisclaimerText>
              Tokens available on this platform are not supported by ZAP. ZAP is
              not an investment service; tokens can lose significant value at
              any moment. By using ZAP, you accept all associated risks and
              agree to our{' '}
              <a
                href="https://docs.zap.tech/zaponchain/other/terms-and-conditions"
                target="_blank"
                rel="noreferrer"
              >
                Terms and Conditions
              </a>
              .
            </DisclaimerText>
          </DisclaimerBox>
          <Box g={10} ac fw>
            <ThemedLink to={routes.labs.index} $styleType="primary">
              Explore Raises
            </ThemedLink>
            <ThemedAnchor
              $styleType="tertiary"
              p="11px 20px 11px 16px"
              href="https://discord.gg/zaponchain"
            >
              <img
                src="/supported-socials/discord.svg"
                alt="ZAP Discord"
                height="20px"
                width="20px"
                style={{ borderRadius: '50%' }}
              />
              Discord
            </ThemedAnchor>
            <ThemedAnchor
              $styleType="tertiary"
              p="11px 20px 11px 16px"
              href="https://x.com/zaponchain"
            >
              <img
                src="/supported-socials/twitter.svg"
                alt="ZAP X"
                height="20px"
                width="20px"
                style={{ borderRadius: '50%' }}
              />
              X
            </ThemedAnchor>
          </Box>
        </>
      }
    />
  )
}

export default ZapLabsArticle
